import SwimmingImage from "../../../../src/posts/swimming-with-men/swimming.jpg";
import * as React from 'react';
export default {
  SwimmingImage,
  React
};